<div class="spinner-placing" *ngIf="loader">
    <p-progressSpinner></p-progressSpinner>
</div>
